import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FileManagementService {
  constructor(private apiService: ApiService) {}
  getFiles(): Observable<any> {
    return this.apiService.get<any>(`/v1/buckets/files/FASTA`);
  }

  deleteFile(filePath: string): Observable<any> {
    const url = `/v1/buckets/file`;
    const parts = filePath.split('/');

    // Remove the first part of the path (e.g., "universit4")
    parts.shift();

    // Reconstruct the file path without the first part
    const modifiedFilePath = parts.join('/'); // Use your API endpoint
    const body = { file_path: modifiedFilePath };
    return this.apiService.delete<any>(url, body); // Use the delete method from ApiService
  }
}
